import Field from '../field';
import { query } from '../api/query';

class Contact {
    fields = [];
    stage = 1;

    constructor(form, bookingNo) {
        this.contactForm = form;
        this.bookingNo = bookingNo;
        this.createFields();
    }

    createFields() {
        this.fields.push(new Field('booking_no', this.contactForm, true, 20));
        // this.fields.push(new Field('original_lead_source_code',this.contactForm, false, 20))
        // this.fields.push(new Field('contact_no',this.contactForm, false, 20))
        // this.fields.push(new Field('salutation_code', false, 20))
        this.fields.push(new Field('first_name', this.contactForm, true, 30));
        // this.fields.push(new Field('middle_name', false, 30))
        this.fields.push(new Field('surname', this.contactForm, true, 30));
        this.fields.push(new Field('address', this.contactForm, true, 50));
        this.fields.push(new Field('address_2', this.contactForm, false, 50));
        this.fields.push(new Field('city', this.contactForm, true, 30));
        this.fields.push(new Field('county', this.contactForm, true, 30));
        this.fields.push(new Field('post_code', this.contactForm, true, 20));
        // this.fields.push(new Field('phone_no', false, 30))
        this.fields.push(new Field('mobile_phone_no', this.contactForm, true, 30));
        // this.fields.push(new Field('fax_no', false, 30))
        this.fields.push(new Field('email', this.contactForm, true, 80));
        this.fields.push(new Field('contact-preference', this.contactForm, false));
        // this.fields.push(new Field('booking_agent_code', false, 20))
        // this.fields.push(new Field('booking_agent_ref_no', false, 20))
    }

    async update(currentStage) {
        if (currentStage == this.stage) {
            const contactInfoPromise = await this.updateContactInfo();
            const updateContactPreferencesPromise = await this.updateContactPreferences();
            const updateBookingAvailabilityPromise = await this.updateBookingAvailability();

            return [contactInfoPromise, updateContactPreferencesPromise, updateBookingAvailabilityPromise];
        }
    }

    async onLoad(currentStage) {
    }

    async updateContactInfo() {
        const URL = this.contactForm.dataset.update_contact_route;
        try {
            const result = await query(URL, this.bookingNo, this.fields); // Await the async query function
            return result; // Return the result to resolve the promise
        } catch (error) {
            console.error('Failed to update contact info:', error.message);
            throw new Error('Error in updateContactInfo: ' + error.message);
        }
    }

    async updateBookingAvailability() {
        const URL = this.contactForm.dataset.update_booking_availability_route;
        try {
            const result = await query(URL, this.bookingNo);

            return result;
        } catch (error) {
            console.error('Failed to update booking availability:', error.message);
            this.resolveBookingError();
            throw new Error('Error in updateBookingAvailability: ' + error.message);
        }
    }

    resolveBookingError() {
        const bookingErrorContainer = document.getElementById('booking-error-container');
        if (bookingErrorContainer) {
            bookingErrorContainer.style.display = 'block';
        }
        const stagesWrapper = document.querySelector('.stages-wrapper');
        if (stagesWrapper) {
            stagesWrapper.remove();
        }
        const formFeedback = document.getElementById('form-feedback');
        if (formFeedback) {
            formFeedback.remove();
        }
        const bookingNav = document.querySelector('.booking-nav');
        if (bookingNav) {
            bookingNav.remove();
        }
    }

    delay(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    async updateContactPreferences() {
        const URL = this.contactForm.dataset.update_contact_preferences_route;

        try {
            // Add a delay of 500ms before making the API request

            const result = await query(URL, this.bookingNo, this.fields);
            return result;
        } catch (error) {
            console.error('Error caught in updateContactPreferences:', error.message);
            throw new Error('Error in updateContactPreferences: ' + error.message);
        }
    }
}

export default Contact;
